import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMatched = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 1C13.6569 1 15 2.34315 15 4V9.375C15 10.9121 13.8436 12.1754 12.3535 12.3506C12.3669 12.2355 12.375 12.1186 12.375 12V11.3379C13.3001 11.1622 14 10.3513 14 9.375V4C14 2.89543 13.1046 2 12 2H6.625C5.64873 2 4.83778 2.69986 4.66211 3.625H4C3.88007 3.625 3.76176 3.63182 3.64551 3.64551C3.82087 2.15571 5.08808 1 6.625 1H12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 4.125,
			width: 10.375,
			height: 10.375,
			rx: 2.5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.2904 8.88294L4.39977 9.77454C3.8959 10.2786 3.8959 11.0967 4.39977 11.6007C4.90381 12.1045 5.72096 12.1036 6.22497 11.5997L7.11559 10.7081L7.82262 11.4152L6.932 12.3068L6.75817 12.465C5.91853 13.1496 4.70625 13.1496 3.86657 12.465L3.69274 12.3077C2.85427 11.4691 2.80189 10.142 3.53551 9.24231L3.69274 9.06751L4.58337 8.17591L5.2904 8.88294ZM7.13415 8.2472C7.305 8.07634 7.58243 8.07634 7.75329 8.2472C7.92382 8.41803 7.92392 8.69459 7.75329 8.86536L6.24059 10.3781C6.06974 10.5489 5.79231 10.5489 5.62145 10.3781C5.45084 10.2072 5.45077 9.93069 5.62145 9.75989L7.13415 8.2472ZM6.61755 6.16028C7.51723 5.42685 8.84345 5.48008 9.682 6.31849L9.8402 6.49231C10.5245 7.33192 10.5246 8.5434 9.8402 9.38294L9.682 9.55677L8.7904 10.4484L8.08337 9.74134L8.97497 8.84974C9.47878 8.34572 9.47877 7.52953 8.97497 7.02552C8.47096 6.52166 7.65381 6.52072 7.14977 7.02454L6.25817 7.91614L5.55114 7.20911L6.44274 6.31751L6.61755 6.16028Z",
			fill: "currentColor"
		})
	]
});
export default SvgMatched;
